import { useEffect, useState } from 'react'
import { Offline } from '@/assets/icons'
import { useOnlineStatus } from '@/context/online-status-context'
import { useDeviceType, DEVICE_TYPE } from '@/hooks/useDeviceType'
import GlobalToastDark from './GlobalToastDark'

/**
 * App-wide notification that appears while the user is offline.
 * Mounted once at the layout level inside `OnlineStatusProvider`.
 */
export default function OfflineIndicatorToast() {
  const isOnline = useOnlineStatus()
  const deviceType = useDeviceType()
  const [dismissed, setDismissed] = useState(false)

  // Reset on reconnect so the next offline event shows the toast again.
  useEffect(() => {
    if (isOnline) setDismissed(false)
  }, [isOnline])

  if (isOnline || dismissed) return null

  const position = deviceType === DEVICE_TYPE.MOBILE ? 'bottom-center' : 'bottom-right'

  return <GlobalToastDark icon={<Offline className="w-[22px] h-[22px]" />} message="Offline" position={position} onClose={() => setDismissed(true)} />
}
